import React from 'react';
import { Route } from 'react-router-dom';

import DocumentTitle from '../generic/DocumentTitle';
import ListInvoices from './ListCategorizedInvoices';
import ShowInvoice from './ShowInvoice';

function Routes() {
  return (
    <DocumentTitle title="Invoices">
      <Route path="/invoices" exact component={ListInvoices} />
      <Route path="/invoices/:id/show" component={ShowInvoice} />
    </DocumentTitle>
  );
}

export default Routes;
